import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Form, Input } from 'antd';
import { withTranslation } from 'react-i18next';

import NumericInput from '../../../components/NumericInput/NumericInput';
import money from '../../../helpers/money';

const InternalTransaction = withTranslation()(
  ({ destination, getFieldDecorator, lookupURL, currency, balance, t }) => (
    <Form layout="vertical">
      <Form.Item label={t('description')}>
        {getFieldDecorator('desc', {
          rules: [
            {
              required: true,
              message: t('transaction.required.desc'),
            },
          ],
        })(<Input name="desc" />)}
      </Form.Item>
      <Form.Item label={t('transaction.destination_name')}>
        {getFieldDecorator('name', {
          rules: [
            {
              required: true,
              message: t('transaction.required.name'),
            },
          ],
        })(<Input name="name" />)}
      </Form.Item>

      <Form.Item label={t('transaction.destination_url')}>
        {getFieldDecorator('url', {
          rules: [
            {
              required: true,
              message: t('transaction.required.url'),
            },
            {
              validator: lookupURL,
            },
          ],
          validateTrigger: 'onBlur',
        })(<Input name="url" />)}
        {(destination) ? (
          <Alert
            type="info"
            message={(
              <>
                <b>{t('destination')}:</b> {destination.name}
              </>
            )}
          />
        ) : (
          ''
        )}
      </Form.Item>

      <Form.Item label={t('amount')}>
        {getFieldDecorator('amount', {
          rules: [
            {
              required: true,
              message: t('transaction.required.amount'),
            },
            {
              validator: (options, value, callback) => {
                const minAmountError = [t('transaction.external.min.amount')];
                const maxAmountError = [t('transaction.external.max.amount')];
                const notNumericAmountError = [t('transaction.external.invalid.numeric_amount')];
                let numericValue;
                try {
                  numericValue = money.toInt(`${value}`, currency, false);
                } catch (error) {
                  console.error('ERROR: money.toInt (InternalTransaction\'s amount validator): ', error); // eslint-disable-line no-console
                }
                let errors;
                switch (true) {
                  case (Number.isNaN(numericValue) && !!value):
                    errors = notNumericAmountError;
                    break;
                  case (numericValue === 0):
                    errors = minAmountError;
                    break;
                  case (numericValue > balance):
                    errors = maxAmountError;
                    break;
                  default:
                    break;
                }
                callback(errors);
              },
            },
          ],
        })(<NumericInput showtooltip showprefix tooltiptitle={t('amount')} currency={currency} name="amount" />)}
      </Form.Item>
    </Form>
  ),
);

InternalTransaction.propTypes = {
  balance: PropTypes.any,
  currency: PropTypes.any,
  destination: PropTypes.any,
  getFieldDecorator: PropTypes.func,
  lookupURL: PropTypes.any,
  t: PropTypes.func,
};

export default InternalTransaction;
